import { render, staticRenderFns } from "./BsAppbarTitle.vue?vue&type=template&id=27a10cc4&scoped=true&"
import script from "./BsAppbarTitle.vue?vue&type=script&lang=js&"
export * from "./BsAppbarTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a10cc4",
  null
  
)

export default component.exports